import { render, staticRenderFns } from "./usuarios_historial.vue?vue&type=template&id=8e0054e8&"
import script from "./usuarios_historial.vue?vue&type=script&lang=js&"
export * from "./usuarios_historial.vue?vue&type=script&lang=js&"
import style0 from "./usuarios_historial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports